<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Beneficiaries</h3>

      <!-- Do you want to change any beneficiaries? -->
      <BeneficiariesYN v-model="form.beneficiariesYN"/>
      <Beneficiaries v-if="form.beneficiariesYN" v-model="form.beneficiaries"/>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import BeneficiariesYN from "@/components/common/questionnaires/question/questions/amendment/BeneficiariesYN.vue";
import Beneficiaries from "@/components/common/questionnaires/question/questions/amendment/Beneficiaries.vue";

export default {
  name: 'BeneficiariesAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    BeneficiariesYN,
    Beneficiaries,
  },
  data() {
    return {
      label: 'Beneficiaries', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
